module.exports = __webpack_public_path__ + "img/TopDown_Single_Frame0001.365d05d5.png";